import '../../App.css'
import { useContext, useEffect, useState } from 'react'
import Aside from '../../component/aside'
import { useNavigate } from 'react-router-dom'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { arrayMove, arrayRemove, List } from 'react-movable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBell,
    faBuilding,
    faChevronDown,
    faCopy,
    faGripVertical,
    faInfoCircle,
    faMapMarkedAlt,
    faMapSigns,
    faPlus,
    faRoute,
    faSave,
    faTimes,
    faTrashAlt,
    faUserTie,
} from '@fortawesome/free-solid-svg-icons'
import { AppContextMenu } from '../../App'

export const buttonStyles = {
    border: 'none',
    margin: 0,
    padding: 0,
    width: 'auto',
    overflow: 'visible',
    cursor: 'pointer',
    background: 'transparent',
}

function FurloughRoutesAdd() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('furloughRoutes')
    }, [])
    const [loading, setLoading] = useState(false)
    const [dataGet, setDataGet] = useState([])
    const [addData, setAddData] = useState({})
    const [addDataSearch, setAddDataSearch] = useState({})
    const [departmentData, setDepartmentData] = useState([])
    const [positionData, setPositionData] = useState([])
    const [positionDataSearch, setPositionDataSearch] = useState([])
    const [routes, setRoutes] = useState([])

    const [positionDataEntitlement, setPositionDataEntitlement] = useState([])
    const [positionDataSearchEntitlement, setPositionDataSearchEntitlement] =
        useState([])

    const [routesEntitlement, setRoutesEntitlement] = useState([])

    const [positionDataNotification, setPositionDataNotification] = useState([])
    const [positionDataSearchNotification, setPositionDataSearchNotification] =
        useState([])

    const [routesNotification, setRoutesNotification] = useState([])

    const [organizations, setOrganizations] = useState([])
    const [selectOrganization, setSelectOrganization] = useState(null)

    const navigate = useNavigate()

    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [navigate])

    useEffect(() => {
        setSelectOrganization(
            RequestQueue.getAuthResult()?.user?.organization_id
        )
        if (RequestQueue.getAuthResult()?.user?.role?.name === 'superAdmin') {
            handlerGetOrganizations()
        }
    }, [])

    useEffect(() => {
        getDepartment()
    }, [selectOrganization])

    const handlerGetOrganizations = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/organization`,
            },
            resolve: (res) => {
                setLoading(false)
                setOrganizations(res.data)
                setSelectOrganization(res.data[0]?.id)
                getDepartment(res.data[0]?.id)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getDepartment = async (selectOrganizationId) => {
        setLoading(true)
        let organizations_id =
            RequestQueue.getAuthResult()?.user?.role?.name === 'superAdmin'
                ? selectOrganization
                : RequestQueue.getAuthResult()?.user?.organization_id

        if (selectOrganizationId) {
            organizations_id = selectOrganizationId
        }
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/department/${organizations_id}`,
            },
            resolve: (res) => {
                setDepartmentData(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
            },
        })
    }

    const getPosition = async (id) => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/position/department/${id}`,
            },
            resolve: (res) => {
                setPositionData(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getPositionEntitlement = async (id) => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/position/department/${id}`,
            },
            resolve: (res) => {
                setPositionDataEntitlement(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getPositionNotification = async (id) => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/position/department/${id}`,
            },
            resolve: (res) => {
                setPositionDataNotification(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getPositionSearch = async (id) => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/position/department/${id}`,
            },
            resolve: (res) => {
                setPositionDataSearch(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getPositionSearchEntitlement = async (id) => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/position/department/${id}`,
            },
            resolve: (res) => {
                setPositionDataSearchEntitlement(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }
    const getPositionSearchNotification = async (id) => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/position/department/${id}`,
            },
            resolve: (res) => {
                setPositionDataSearchNotification(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const setQueryPropertyAddData = (key, e) => {
        switch (key) {
            case 'department_id':
                if (e.target.value !== 'none') {
                    setAddData({ ...addData, department_id: e.target.value })
                    getPosition(e.target.value)
                } else {
                    setAddData({ ...addData, department_id: undefined })
                }
                break
            case 'position_id':
                setAddData({ ...addData, position_id: e.target.value })
                break
            case 'department_idEntitlement':
                if (e.target.value !== 'none') {
                    setAddData({
                        ...addData,
                        department_idEntitlement: e.target.value,
                    })
                    getPositionEntitlement(e.target.value)
                } else {
                    setAddData({
                        ...addData,
                        department_idEntitlement: undefined,
                    })
                }
                break
            case 'position_idEntitlement':
                setAddData({
                    ...addData,
                    position_idEntitlement: e.target.value,
                })
                break
            case 'department_idNotification':
                if (e.target.value !== 'none') {
                    setAddData({
                        ...addData,
                        department_idNotification: e.target.value,
                    })
                    getPositionNotification(e.target.value)
                } else {
                    setAddData({
                        ...addData,
                        department_idNotification: undefined,
                    })
                }
                break
            case 'position_idNotification':
                setAddData({
                    ...addData,
                    position_idNotification: e.target.value,
                })
                break
            default:
                return null
        }
    }

    const setQueryPropertyDataSearch = (key, e) => {
        switch (key) {
            case 'department':
                if (e.target.value !== 'none') {
                    const department = departmentData.find(
                        (d) => d.id === e.target.value
                    )
                    setAddDataSearch({
                        ...addDataSearch,
                        department: department,
                    })

                    getPositionSearch(e.target.value)
                } else {
                    setAddDataSearch({
                        ...addDataSearch,
                        department: undefined,
                    })
                }
                break
            case 'position':
                const position = positionDataSearch.find(
                    (p) => p.id === e.target.value
                )
                setAddDataSearch({ ...addDataSearch, position: position })
                break
            case 'departmentEntitlement':
                if (e.target.value !== 'none') {
                    const department = departmentData.find(
                        (d) => d.id === e.target.value
                    )
                    setAddDataSearch({
                        ...addDataSearch,
                        departmentEntitlement: department,
                    })

                    getPositionSearchEntitlement(e.target.value)
                } else {
                    setAddDataSearch({
                        ...addDataSearch,
                        departmentEntitlement: undefined,
                    })
                }
                break
            case 'positionEntitlement':
                const positionEntitlement = positionDataSearchEntitlement.find(
                    (p) => p.id === e.target.value
                )
                setAddDataSearch({
                    ...addDataSearch,
                    positionEntitlement: positionEntitlement,
                })
                break
            case 'departmentNotification':
                if (e.target.value !== 'none') {
                    const department = departmentData.find(
                        (d) => d.id === e.target.value
                    )
                    setAddDataSearch({
                        ...addDataSearch,
                        departmentNotification: department,
                    })

                    getPositionSearchNotification(e.target.value)
                } else {
                    setAddDataSearch({
                        ...addDataSearch,
                        departmentNotification: undefined,
                    })
                }
                break
            case 'positionNotification':
                const positionNotification =
                    positionDataSearchNotification.find(
                        (p) => p.id === e.target.value
                    )
                setAddDataSearch({
                    ...addDataSearch,
                    positionNotification: positionNotification,
                })
                break
            default:
                return null
        }
    }

    const handlerSubmit = async () => {
        setLoading(true)
        await RequestQueue.sendRequest({
            config: {
                method: 'post',
                url: `/furlough-routes`,
                data: {
                    position_id: addData.position_id,
                    department_id: addData.department_id,
                    routes: routes,
                    routes_entitlement_more_then: routesEntitlement,
                    routes_receive_notifications: routesNotification,
                    organization_id: selectOrganization,
                },
            },
            resolve: (res) => {
                setLoading(false)
                navigate('/furloughRoutes')
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handlerCancel = () => {
        navigate(-1)
    }

    const handlerAddRoute = () => {
        if (addDataSearch.department && addDataSearch.position) {
            const newRoute = {
                name: `${addDataSearch.department.name} -> ${addDataSearch.position.name}`,
                department_id: addDataSearch.department.id,
                position_id: addDataSearch.position.id,
            }
            setRoutes([...routes, newRoute])
        } else {
            toast.error('لطفاً بخش کاری و جایگاه شغلی را انتخاب کنید', {
                position: 'bottom-center',
            })
        }
    }
    const handlerAddRouteEntitlement = () => {
        if (
            addDataSearch.departmentEntitlement &&
            addDataSearch.positionEntitlement
        ) {
            const newRoute = {
                name: `${addDataSearch.departmentEntitlement.name} -> ${addDataSearch.positionEntitlement.name}`,
                department_id: addDataSearch.departmentEntitlement.id,
                position_id: addDataSearch.positionEntitlement.id,
            }
            setRoutesEntitlement([...routesEntitlement, newRoute])
        } else {
            toast.error('لطفاً بخش کاری و جایگاه شغلی را انتخاب کنید', {
                position: 'bottom-center',
            })
        }
    }
    const handlerAddRouteNotification = () => {
        if (
            addDataSearch.departmentNotification &&
            addDataSearch.positionNotification
        ) {
            const newRoute = {
                name: `${addDataSearch.departmentNotification.name} -> ${addDataSearch.positionNotification.name}`,
                department_id: addDataSearch.departmentNotification.id,
                position_id: addDataSearch.positionNotification.id,
            }
            setRoutesNotification([...routesNotification, newRoute])
        } else {
            toast.error('لطفاً بخش کاری و جایگاه شغلی را انتخاب کنید', {
                position: 'bottom-center',
            })
        }
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />

                    <div className="bg-white rounded-xl shadow-lg  border border-gray-200 mx-4 my-6">
                        {/* Header */}
                        <div className="px-6 py-5 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                            <h2 className="text-2xl font-bold text-white">
                                <FontAwesomeIcon
                                    icon={faRoute}
                                    className="ml-2"
                                />
                                افزودن مسیر مرخصی
                            </h2>
                        </div>

                        {/* Form Content */}
                        <div className="p-6 space-y-6">
                            {/* Instructions */}
                            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                <p className="text-blue-800 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faInfoCircle}
                                        className="ml-2"
                                    />
                                    ابتدا بخش کاری و سپس جایگاه شغلی مورد نظر
                                    خود را انتخاب کنید
                                </p>
                            </div>

                            {RequestQueue.getAuthResult()?.user?.role?.name ===
                                'superAdmin' && (
                                <div className="space-y-2">
                                    <label className=" text-sm font-medium text-gray-700 flex items-center">
                                        <FontAwesomeIcon
                                            icon={faBuilding}
                                            className="ml-2"
                                        />
                                        سازمان
                                    </label>
                                    <select
                                        className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                        onChange={(e) => {
                                            setSelectOrganization(
                                                e.target.value
                                            )
                                        }}
                                    >
                                        {organizations.map((d) => {
                                            return (
                                                <option
                                                    value={d.id}
                                                    selected={
                                                        d.id ===
                                                        selectOrganization
                                                    }
                                                >
                                                    {d.name}
                                                </option>
                                            )
                                        })}
                                    </select>
                                </div>
                            )}

                            {/* Department Selection */}
                            <div className="space-y-2">
                                <label className="block text-sm font-medium text-gray-700 flex items-center">
                                    <FontAwesomeIcon
                                        icon={faBuilding}
                                        className="ml-2"
                                    />
                                    بخش کاری
                                </label>
                                <div className="relative">
                                    <select
                                        className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                        onChange={(e) => {
                                            setQueryPropertyAddData(
                                                'department_id',
                                                e
                                            )
                                        }}
                                    >
                                        <option value="none" selected>
                                            انتخاب کنید
                                        </option>
                                        {departmentData.map((d) => (
                                            <option key={d.id} value={d.id}>
                                                {d.name}
                                            </option>
                                        ))}
                                    </select>
                                    <FontAwesomeIcon
                                        icon={faChevronDown}
                                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                    />
                                </div>
                            </div>

                            {/* Position Selection */}
                            {addData.department_id !== undefined &&
                                addData.department_id && (
                                    <div className="space-y-2">
                                        <label className="block text-sm font-medium text-gray-700 flex items-center">
                                            <FontAwesomeIcon
                                                icon={faUserTie}
                                                className="ml-2"
                                            />
                                            جایگاه شغلی
                                        </label>
                                        <div className="relative">
                                            <select
                                                className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                                onChange={(e) => {
                                                    setQueryPropertyAddData(
                                                        'position_id',
                                                        e
                                                    )
                                                }}
                                            >
                                                <option value="none" selected>
                                                    انتخاب کنید
                                                </option>
                                                {positionData.map((d) => (
                                                    <option
                                                        key={d.id}
                                                        value={d.id}
                                                    >
                                                        {d.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <FontAwesomeIcon
                                                icon={faChevronDown}
                                                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                            />
                                        </div>
                                    </div>
                                )}

                            {/* Main Furlough Route */}
                            {addData.position_id !== undefined &&
                                addData.position_id && (
                                    <>
                                        <div className="border-t border-gray-600 pt-6 mt-6">
                                            <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                                                <FontAwesomeIcon
                                                    icon={faMapSigns}
                                                    className="ml-2"
                                                />
                                                مسیر مرخصی اصلی
                                            </h3>

                                            <div className="flex flex-col md:flex-row gap-4 mt-4">
                                                <div className="flex-1 space-y-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        بخش کاری
                                                    </label>
                                                    <div className="relative">
                                                        <select
                                                            className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                                            onChange={(e) => {
                                                                setQueryPropertyDataSearch(
                                                                    'department',
                                                                    e
                                                                )
                                                            }}
                                                        >
                                                            <option
                                                                value="none"
                                                                selected
                                                            >
                                                                انتخاب کنید
                                                            </option>
                                                            {departmentData.map(
                                                                (d) => (
                                                                    <option
                                                                        key={
                                                                            d.id
                                                                        }
                                                                        value={
                                                                            d.id
                                                                        }
                                                                    >
                                                                        {d.name}
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                        <FontAwesomeIcon
                                                            icon={faChevronDown}
                                                            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                        />
                                                    </div>
                                                </div>

                                                {addDataSearch.department !==
                                                    undefined &&
                                                    addDataSearch.department && (
                                                        <div className="flex-1 space-y-2">
                                                            <label className="block text-sm font-medium text-gray-700">
                                                                جایگاه شغلی
                                                            </label>
                                                            <div className="relative">
                                                                <select
                                                                    className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        setQueryPropertyDataSearch(
                                                                            'position',
                                                                            e
                                                                        )
                                                                    }}
                                                                >
                                                                    <option
                                                                        value="none"
                                                                        selected
                                                                    >
                                                                        انتخاب
                                                                        کنید
                                                                    </option>
                                                                    {positionDataSearch.map(
                                                                        (d) => (
                                                                            <option
                                                                                key={
                                                                                    d.id
                                                                                }
                                                                                value={
                                                                                    d.id
                                                                                }
                                                                            >
                                                                                {
                                                                                    d.name
                                                                                }
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </select>
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faChevronDown
                                                                    }
                                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                <div className="flex items-end">
                                                    <button
                                                        className="px-4 py-3 rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 transition-colors flex items-center"
                                                        onClick={
                                                            handlerAddRoute
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faPlus}
                                                            className="ml-2"
                                                        />
                                                        افزودن
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Routes List */}
                                            <div className="mt-6 space-y-3">
                                                <List
                                                    values={routes}
                                                    onChange={({
                                                        oldIndex,
                                                        newIndex,
                                                    }) =>
                                                        setRoutes(
                                                            arrayMove(
                                                                routes,
                                                                oldIndex,
                                                                newIndex
                                                            )
                                                        )
                                                    }
                                                    renderList={({
                                                        children,
                                                        props,
                                                        isDragged,
                                                    }) => (
                                                        <ul
                                                            {...props}
                                                            className={`space-y-3 ${
                                                                isDragged
                                                                    ? 'cursor-grabbing'
                                                                    : 'cursor-grab'
                                                            }`}
                                                        >
                                                            {children}
                                                        </ul>
                                                    )}
                                                    renderItem={({
                                                        value,
                                                        props,
                                                        index,
                                                        isDragged,
                                                        isSelected,
                                                    }) => (
                                                        <li
                                                            {...props}
                                                            key={props.key}
                                                            className={`p-4 border rounded-lg flex items-center justify-between ${
                                                                isDragged ||
                                                                isSelected
                                                                    ? 'bg-gray-100 border-indigo-300'
                                                                    : 'bg-white border-gray-200'
                                                            }`}
                                                        >
                                                            <div className="flex items-center">
                                                                <button
                                                                    data-movable-handle
                                                                    className="text-gray-500 mr-3 text-xl cursor-grab"
                                                                    tabIndex={
                                                                        -1
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faGripVertical
                                                                        }
                                                                    />
                                                                </button>
                                                                <span className="bg-indigo-600 text-white w-6 h-6 rounded-full flex items-center justify-center mx-2">
                                                                    {index + 1}
                                                                </span>
                                                                <span>
                                                                    {value.name}
                                                                </span>
                                                            </div>
                                                            <button
                                                                onClick={() => {
                                                                    setRoutes(
                                                                        typeof index !==
                                                                            'undefined'
                                                                            ? arrayRemove(
                                                                                  routes,
                                                                                  index
                                                                              )
                                                                            : routes
                                                                    )
                                                                }}
                                                                className="text-red-500 hover:text-red-700"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faTrashAlt
                                                                    }
                                                                />
                                                            </button>
                                                        </li>
                                                    )}
                                                />
                                            </div>
                                        </div>

                                        {/* Entitlement Furlough Route */}
                                        <div className="border-t border-gray-600 pt-6 mt-6">
                                            <div className="flex justify-between maxLg:flex-col items-center">
                                                <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                                                    <FontAwesomeIcon
                                                        icon={faMapMarkedAlt}
                                                        className="ml-2"
                                                    />
                                                    مسیر مرخصی بیشتر از مرخصی
                                                    استحقاقی
                                                </h3>
                                                <button
                                                    className="px-4 py-2 rounded-xl text-white bg-amber-500 hover:bg-amber-600 transition-colors flex items-center"
                                                    onClick={() => {
                                                        setRoutesEntitlement(
                                                            routes
                                                        )
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faCopy}
                                                        className="ml-2"
                                                    />
                                                    کپی از مسیر مرخصی اصلی
                                                </button>
                                            </div>

                                            <div className="flex flex-col md:flex-row gap-4 mt-4">
                                                <div className="flex-1 space-y-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        بخش کاری
                                                    </label>
                                                    <div className="relative">
                                                        <select
                                                            className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                                            onChange={(e) => {
                                                                setQueryPropertyDataSearch(
                                                                    'departmentEntitlement',
                                                                    e
                                                                )
                                                            }}
                                                        >
                                                            <option
                                                                value="none"
                                                                selected
                                                            >
                                                                انتخاب کنید
                                                            </option>
                                                            {departmentData.map(
                                                                (d) => (
                                                                    <option
                                                                        key={
                                                                            d.id
                                                                        }
                                                                        value={
                                                                            d.id
                                                                        }
                                                                    >
                                                                        {d.name}
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                        <FontAwesomeIcon
                                                            icon={faChevronDown}
                                                            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                        />
                                                    </div>
                                                </div>

                                                {addDataSearch.departmentEntitlement !==
                                                    undefined &&
                                                    addDataSearch.departmentEntitlement && (
                                                        <div className="flex-1 space-y-2">
                                                            <label className="block text-sm font-medium text-gray-700">
                                                                جایگاه شغلی
                                                            </label>
                                                            <div className="relative">
                                                                <select
                                                                    className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        setQueryPropertyDataSearch(
                                                                            'positionEntitlement',
                                                                            e
                                                                        )
                                                                    }}
                                                                >
                                                                    <option
                                                                        value="none"
                                                                        selected
                                                                    >
                                                                        انتخاب
                                                                        کنید
                                                                    </option>
                                                                    {positionDataSearchEntitlement.map(
                                                                        (d) => (
                                                                            <option
                                                                                key={
                                                                                    d.id
                                                                                }
                                                                                value={
                                                                                    d.id
                                                                                }
                                                                            >
                                                                                {
                                                                                    d.name
                                                                                }
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </select>
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faChevronDown
                                                                    }
                                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                <div className="flex items-end">
                                                    <button
                                                        className="px-4 py-3 rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 transition-colors flex items-center"
                                                        onClick={
                                                            handlerAddRouteEntitlement
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faPlus}
                                                            className="ml-2"
                                                        />
                                                        افزودن
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Entitlement Routes List */}
                                            <div className="mt-6 space-y-3">
                                                <List
                                                    values={routesEntitlement}
                                                    onChange={({
                                                        oldIndex,
                                                        newIndex,
                                                    }) =>
                                                        setRoutesEntitlement(
                                                            arrayMove(
                                                                routesEntitlement,
                                                                oldIndex,
                                                                newIndex
                                                            )
                                                        )
                                                    }
                                                    renderList={({
                                                        children,
                                                        props,
                                                        isDragged,
                                                    }) => (
                                                        <ul
                                                            {...props}
                                                            className={`space-y-3 ${
                                                                isDragged
                                                                    ? 'cursor-grabbing'
                                                                    : 'cursor-grab'
                                                            }`}
                                                        >
                                                            {children}
                                                        </ul>
                                                    )}
                                                    renderItem={({
                                                        value,
                                                        props,
                                                        index,
                                                        isDragged,
                                                        isSelected,
                                                    }) => (
                                                        <li
                                                            {...props}
                                                            key={props.key}
                                                            className={`p-4 border rounded-lg flex items-center justify-between ${
                                                                isDragged ||
                                                                isSelected
                                                                    ? 'bg-gray-100 border-indigo-300'
                                                                    : 'bg-white border-gray-200'
                                                            }`}
                                                        >
                                                            <div className="flex items-center">
                                                                <button
                                                                    data-movable-handle
                                                                    className="text-gray-500 mr-3 text-xl cursor-grab"
                                                                    tabIndex={
                                                                        -1
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faGripVertical
                                                                        }
                                                                    />
                                                                </button>
                                                                <span className="bg-indigo-600 text-white w-6 h-6 rounded-full flex items-center justify-center mx-2">
                                                                    {index + 1}
                                                                </span>
                                                                <span>
                                                                    {value.name}
                                                                </span>
                                                            </div>
                                                            <button
                                                                onClick={() => {
                                                                    setRoutesEntitlement(
                                                                        typeof index !==
                                                                            'undefined'
                                                                            ? arrayRemove(
                                                                                  routesEntitlement,
                                                                                  index
                                                                              )
                                                                            : routesEntitlement
                                                                    )
                                                                }}
                                                                className="text-red-500 hover:text-red-700"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faTrashAlt
                                                                    }
                                                                />
                                                            </button>
                                                        </li>
                                                    )}
                                                />
                                            </div>
                                        </div>

                                        {/* Notification Route */}
                                        <div className="border-t border-gray-600 pt-6 mt-6">
                                            <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                                                <FontAwesomeIcon
                                                    icon={faBell}
                                                    className="ml-2"
                                                />
                                                مسیر نوتیفیکیشن مرخصی
                                            </h3>

                                            <div className="flex flex-col md:flex-row gap-4 mt-4">
                                                <div className="flex-1 space-y-2">
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        بخش کاری
                                                    </label>
                                                    <div className="relative">
                                                        <select
                                                            className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                                            onChange={(e) => {
                                                                setQueryPropertyDataSearch(
                                                                    'departmentNotification',
                                                                    e
                                                                )
                                                            }}
                                                        >
                                                            <option
                                                                value="none"
                                                                selected
                                                            >
                                                                انتخاب کنید
                                                            </option>
                                                            {departmentData.map(
                                                                (d) => (
                                                                    <option
                                                                        key={
                                                                            d.id
                                                                        }
                                                                        value={
                                                                            d.id
                                                                        }
                                                                    >
                                                                        {d.name}
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                        <FontAwesomeIcon
                                                            icon={faChevronDown}
                                                            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                        />
                                                    </div>
                                                </div>

                                                {addDataSearch.departmentNotification !==
                                                    undefined &&
                                                    addDataSearch.departmentNotification && (
                                                        <div className="flex-1 space-y-2">
                                                            <label className="block text-sm font-medium text-gray-700">
                                                                جایگاه شغلی
                                                            </label>
                                                            <div className="relative">
                                                                <select
                                                                    className="w-full px-4 py-3 border bg-white border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        setQueryPropertyDataSearch(
                                                                            'positionNotification',
                                                                            e
                                                                        )
                                                                    }}
                                                                >
                                                                    <option
                                                                        value="none"
                                                                        selected
                                                                    >
                                                                        انتخاب
                                                                        کنید
                                                                    </option>
                                                                    {positionDataSearchNotification.map(
                                                                        (d) => (
                                                                            <option
                                                                                key={
                                                                                    d.id
                                                                                }
                                                                                value={
                                                                                    d.id
                                                                                }
                                                                            >
                                                                                {
                                                                                    d.name
                                                                                }
                                                                            </option>
                                                                        )
                                                                    )}
                                                                </select>
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faChevronDown
                                                                    }
                                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                                />
                                                            </div>
                                                        </div>
                                                    )}

                                                <div className="flex items-end">
                                                    <button
                                                        className="px-4 py-3 rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 transition-colors flex items-center"
                                                        onClick={
                                                            handlerAddRouteNotification
                                                        }
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faPlus}
                                                            className="ml-2"
                                                        />
                                                        افزودن
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Notification Routes List */}
                                            <div className="mt-6 space-y-3">
                                                <List
                                                    values={routesNotification}
                                                    onChange={({
                                                        oldIndex,
                                                        newIndex,
                                                    }) =>
                                                        setRoutesNotification(
                                                            arrayMove(
                                                                routesNotification,
                                                                oldIndex,
                                                                newIndex
                                                            )
                                                        )
                                                    }
                                                    renderList={({
                                                        children,
                                                        props,
                                                        isDragged,
                                                    }) => (
                                                        <ul
                                                            {...props}
                                                            className={`space-y-3 ${
                                                                isDragged
                                                                    ? 'cursor-grabbing'
                                                                    : 'cursor-grab'
                                                            }`}
                                                        >
                                                            {children}
                                                        </ul>
                                                    )}
                                                    renderItem={({
                                                        value,
                                                        props,
                                                        index,
                                                        isDragged,
                                                        isSelected,
                                                    }) => (
                                                        <li
                                                            {...props}
                                                            key={props.key}
                                                            className={`p-4 border rounded-lg flex items-center justify-between ${
                                                                isDragged ||
                                                                isSelected
                                                                    ? 'bg-gray-100 border-indigo-300'
                                                                    : 'bg-white border-gray-200'
                                                            }`}
                                                        >
                                                            <div className="flex items-center">
                                                                <button
                                                                    data-movable-handle
                                                                    className="text-gray-500 mr-3 text-xl cursor-grab"
                                                                    tabIndex={
                                                                        -1
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faGripVertical
                                                                        }
                                                                    />
                                                                </button>
                                                                <span className="bg-indigo-600 text-white w-6 h-6 rounded-full flex items-center justify-center mx-2">
                                                                    {index + 1}
                                                                </span>
                                                                <span>
                                                                    {value.name}
                                                                </span>
                                                            </div>
                                                            <button
                                                                onClick={() => {
                                                                    setRoutesNotification(
                                                                        typeof index !==
                                                                            'undefined'
                                                                            ? arrayRemove(
                                                                                  routesNotification,
                                                                                  index
                                                                              )
                                                                            : routesNotification
                                                                    )
                                                                }}
                                                                className="text-red-500 hover:text-red-700"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faTrashAlt
                                                                    }
                                                                />
                                                            </button>
                                                        </li>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}

                            {/* Form Actions */}
                            <div className="flex justify-end space-x-3 space-x-reverse pt-6 maxLg:flex-col border-t border-gray-200 mt-6">
                                <button
                                    type="button"
                                    onClick={handlerCancel}
                                    className="px-6 maxLg:my-2 py-3 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-colors flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        className="ml-2"
                                    />
                                    انصراف
                                </button>
                                <button
                                    type="button"
                                    onClick={handlerSubmit}
                                    className="px-6 py-3 maxLg:my-2 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg flex items-center"
                                >
                                    <FontAwesomeIcon
                                        icon={faSave}
                                        className="ml-2"
                                    />
                                    ثبت مسیرها
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default FurloughRoutesAdd
